import { RootStore } from 'Portals/Customer/stores'

import { MouTable } from './MouTable'

export class MouStore {
	table: MouTable
	rootStore: RootStore

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore
		this.table = new MouTable(rootStore)
	}
}
